import React, { Fragment, useContext } from 'react'
import { Button, Card, Grid, List, ListItem, Message } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../App/stores/RootStore'
import AdminSettingForm from './Form/AdminSettingForm';
import { IAdminSetting } from '../../../App/models/AdminSetting';

const SettingsList: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { AdminSettingsById } = rootStore.adminSettingStore;
    const { openModal } = rootStore.modalStore;

    return (
        <Fragment>
            <Grid columns={3} divided style={{ overflowY: "auto" }}>
                {AdminSettingsById.map((adminSetting: IAdminSetting) => (
                    <Grid.Column width={8} key={adminSetting.id}>
                        <Card.Group>
                            <Card fluid>
                                <Card.Content>
                                    <Card.Header>
                                        {adminSetting.key}
                                    </Card.Header>
                                    <Card.Meta>
                                        <List>
                                            <ListItem>Value: {adminSetting.value}</ListItem>
                                            <Button
                                                className={'rl-btn'}
                                                onClick={() => openModal(<AdminSettingForm id={adminSetting.id} Adminkey={adminSetting.key} value={adminSetting.value} />)}
                                                icon='edit'
                                                content="Edit"
                                            />
                                        </List>
                                    </Card.Meta>
                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </Grid.Column>
                ))}
            </Grid>
        </Fragment>
    )
}
export default observer(SettingsList);